// extracted by mini-css-extract-plugin
module.exports = {"activityListItem":"_9JT-y","activityListItemDescription":"_91hI1","descriptionTextWrapper":"dr1db","activityIconWrapper":"jdwNa","withPadding":"rZiBh"};